import { SET_CASH_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const cashUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CASH_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default cashUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/CASH/reducer.js